import { createContext } from "react"

export interface AboutDoctorInterface {
  showSuccessMsg: boolean, setShowSuccessMsg: (showSuccessMsg: boolean) => void,
}

export const DefaultAboutDoctorInterface:AboutDoctorInterface = {
  showSuccessMsg: false, setShowSuccessMsg: () => {},
}

export const AboutDoctorContext = createContext<AboutDoctorInterface>(DefaultAboutDoctorInterface)

